// extracted by mini-css-extract-plugin
export default {"pdfMobilePreview":"PreviewModal_pdfMobilePreview__eg8BL","pdfDesktopPreview":"PreviewModal_pdfDesktopPreview__k-rDq"};